// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 720px){.R8E9e6SyHZrnOS1SreSS{--beam--row-edge-2-edge-offset: 0px}}`, "",{"version":3,"sources":["webpack://./../../mfe/serviceability/src/components/MultiFieldAddress/multiFieldAddress.module.scss"],"names":[],"mappings":"AACE,qCADF,sBAEI,mCAAA,CAAA","sourcesContent":[".root {\n  @media screen and (max-width: 720px) {\n    --beam--row-edge-2-edge-offset: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `R8E9e6SyHZrnOS1SreSS`
};
export default ___CSS_LOADER_EXPORT___;
